import { render, staticRenderFns } from "./multi-select-bb.vue?vue&type=template&id=5da415fc&scoped=true"
import script from "./multi-select-bb.vue?vue&type=script&lang=js"
export * from "./multi-select-bb.vue?vue&type=script&lang=js"
import style0 from "./multi-select-bb.vue?vue&type=style&index=0&id=5da415fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da415fc",
  null
  
)

export default component.exports